import classNames from 'classnames';
import React from 'react';
import { useRefinementList } from 'react-instantsearch-hooks-web';

const SearchFiltersMenu = ( props ) => {
	const { attribute, id, label } = props;
	// useMenu was not returning any items
	const { items, refine } = useRefinementList( {
		attribute,
		sortBy: [ 'name:asc' ],
		limit: 100,
	} );

	return (
		<div className={`${ items.length === 0 ? 'tw-hidden' : '' }`}>
			<div className="tw-font-bold tw-mb-2 tw-mt-6">{label}</div>
			<ul className="tw-list-none tw-flex tw-pl-0 tw-space-x-3">
				{items.map( ( item, length ) => {
					const isActive = item.isRefined;
					const klasses = classNames( {
						'tw-bg-white  tw-border-steel tw-text-charcoal hover:tw-bg-aloe hover:tw-border-steel': ! isActive,
						'tw-bg-melon tw-border-charcoal hover:tw-bg-melon hover:tw-text-charcoal hover:tw-border-charcoal': isActive,
					} );
					return (
						<li className="" key={`${ id }-${ item.value }`}>
							<label
								className={`gtm-search-filter ${ klasses } tw-cursor-pointer tw-flex tw-border tw-rounded-full tw-px-2`}
								data-insights-filters={`${ attribute }:${ item.value }`}
							>
								<input
									type="radio"
									className="tw-hidden"
									name={id}
									value={item.value}
									checked={item.isRefined}
									onClick={() => {
										if ( isActive ) {
											refine( item.value );
										}
									}}
									onChange={() => {
										refine( item.value );
									}}
								/>
								<span className="tw-ml-1">{item.label}</span>
							</label>
						</li>
					);
				} )}
			</ul>
		</div>
	);
};

export default SearchFiltersMenu;
